import type { ChangeEventHandler, CSSProperties, InputHTMLAttributes } from "react"
import { cn } from "@/lib/utils"

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "value" | "min" | "max" | "onChange"> & {
  value: number
  min: number
  max: number
  onChange?: ChangeEventHandler<HTMLInputElement>
}

/** Themed range: track + thumb share hover; active keeps same color (no press tint). */
export function UiRange({ className, value, min, max, style, onChange, ...rest }: Props) {
  const span = max - min
  const pct = span <= 0 ? 0 : Math.min(100, Math.max(0, ((Number(value) - min) / span) * 100))

  return (
    <input
      type="range"
      min={min}
      max={max}
      value={value}
      onChange={onChange}
      className={cn("ui-range", className)}
      style={{ ...style, ["--ui-range-pct"]: `${pct}%` } as CSSProperties}
      {...rest}
    />
  )
}
